// ฟังก์ชันช่วยจัดการรอบการจัดส่ง ใช้ร่วมกันระหว่างหน้ารายการใบจองของเกษตรกรและของเจ้าหน้าที่

const getPeriodStartTime = (period) => new Date(period.PeriodStart).getTime();

const findPeriodByName = (periods, deliveryPeriod) =>
  periods.find((p) => p.DeliveryPeriod === deliveryPeriod);

const sortPeriodsAsc = (periods) =>
  [...periods].sort((a, b) => getPeriodStartTime(a) - getPeriodStartTime(b));

// เลือกเฉพาะรอบที่เริ่มแล้ว เพราะรอบที่ยังไม่เริ่มจะยังไม่มีใบจอง
export const getValidPeriods = (periods) => {
  const today = new Date();
  return periods.filter((period) => new Date(period.PeriodStart) <= today);
};

// รอบสิ้นสุดต้องไม่เก่ากว่ารอบเริ่มต้นที่เลือกไว้
export const getEndPeriodOptions = (periods, startDeliveryPeriod) => {
  if (!startDeliveryPeriod) {
    return periods;
  }
  const startPeriod = findPeriodByName(periods, startDeliveryPeriod);
  if (!startPeriod) {
    return periods;
  }
  const startTime = getPeriodStartTime(startPeriod);
  return sortPeriodsAsc(
    periods.filter((p) => getPeriodStartTime(p) >= startTime)
  );
};

export const isPeriodAfter = (periods, deliveryPeriodA, deliveryPeriodB) => {
  const periodA = findPeriodByName(periods, deliveryPeriodA);
  const periodB = findPeriodByName(periods, deliveryPeriodB);
  if (!periodA || !periodB) {
    return deliveryPeriodA > deliveryPeriodB;
  }
  return getPeriodStartTime(periodA) > getPeriodStartTime(periodB);
};
